import confirmDialog from "./ConfirmDialog";
import RemotingService from "../../services/remoting-service/RemotingService";

export default function confirmAndDeleteDialog(header, message, url, callback, submitContent = "Confirm", closeContent, preDeleteCallback) {
    confirmDialog(header, message, () => {
        if (preDeleteCallback) {
            preDeleteCallback();
        }
        RemotingService.deleteRemoteCall(url, null, callback);
    }, null, null, submitContent, closeContent);
}
